interface VisitListLoadingProps {
  className?: string;
}

const VisitListLoading: React.FC<VisitListLoadingProps> = ({
  className,
}) => {
  return (
    <div className={className}>
      {/* Current Visits Section */}
      <section className="mb-8">
        <div className="space-y-4">
          {/* Visit Card Skeleton */}
          <div className="p-6 border border-foreground-muted/20 bg-surface-elevated rounded-2xl shadow-card animate-pulse">
            <div className="flex justify-between items-start mb-4">
              {/* Avatar Group Skeleton */}
              <div className="flex items-center space-x-2">
                <div className="w-10 h-10 bg-surface rounded-full"></div>
                <div className="w-10 h-10 bg-surface rounded-full -ml-2"></div>
              </div>

              {/* Status and Timestamp Skeleton */}
              <div className="flex flex-col items-end space-y-1">
                <div className="h-4 bg-surface rounded w-20"></div>
                <div className="h-3 bg-surface rounded w-16"></div>
              </div>
            </div>

            {/* Content Skeleton */}
            <div className="space-y-2">
              <div className="h-5 bg-surface rounded w-3/4"></div>
              <div className="h-4 bg-surface rounded w-1/2"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VisitListLoading;
